import { render, staticRenderFns } from "./page_layout.vue?vue&type=template&id=7dd0949a&"
import script from "./page_layout.vue?vue&type=script&lang=js&"
export * from "./page_layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports